<template>
  <div class="common-bg">
    <div class="tool-drawer-header">
      <a @click="clickBack">
        <a-icon type="left" />
      </a>
      <div class="title">{{$t('edit.injectInfo.addVideo')}}</div>
    </div>
    <div class="tool-drawer-content">
      <!-- 標題 -->
      <div class="tit-box" style="padding-top: 0">
        <div class="tit-desc">
          <span>{{$t('edit.title')}}</span>
          <a-checkbox :checked="pasterObj.is_auto_play === 1" @change="isAutoPlay">自動播放</a-checkbox>
        </div>
        <a-input :placeholder="$t('edit.hpInfo.inputTitle')" v-model="pasterObj.title" />
      </div>
      <!-- 選擇影片 -->
      <div style="margin: 10px 20px">
        <material-select :type="3" @selected="handleSelectedVideo">
          <template slot="body">
            <a-button type="primary" ghost >{{$t('edit.hpInfo.videoSelect')}}</a-button>
          </template>
        </material-select>
        <!-- 顯示影片 -->
        <div v-show="pasterObj.url" style="margin-top: 10px">
          <video style="width: 100%" :src="pasterObj.url"></video>
        </div>
      </div>

      <div style="margin: 10px 20px">
        <div style="line-height: 4">{{$t('edit.injectInfo.videoCover')}}</div>

        <material-select :type="1" @selected="handleSelectedCover">
          <template slot="body">
            <a-button type="primary" ghost>{{$t('edit.injectInfo.setCover')}}</a-button>
          </template>
        </material-select>
        <div v-show="pasterObj.posterurl" style="margin-top: 10px">
          <img style="width: 100%" :src="pasterObj.posterurl" />
        </div>
      </div>

      <div style="margin: 20px 24px">
        <div style="display: flex; justify-content: space-between">
          <div>{{$t('edit.injectInfo.tinyAdjust')}}</div>
          <a class="edit" @click="resetData">{{$t('actionTitles.reset')}}</a>
        </div>
        <a-row style="margin-top: 10px">
          <a-col :span="4">
            <img
                    style="width: 30px; height: 30px"
                    src="../../assets/img/x-rotate.png"
            />
          </a-col>
          <a-col :span="14">
            <a-slider v-model="pasterObj.rx" :min="-180" :max="180" />
          </a-col>
          <a-col :span="6">
            <a-input-number v-model="pasterObj.rx" style="height: 30px; width:auto" />
          </a-col>
        </a-row>
        <a-row style="margin-top: 10px">
          <a-col :span="4">
            <img
                    style="width: 30px; height: 30px"
                    src="../../assets/img/y-rotate.png"
            />
          </a-col>
          <a-col :span="14">
            <a-slider v-model="pasterObj.ry" :min="-180" :max="180"/>
          </a-col>
          <a-col :span="6">
            <a-input-number v-model="pasterObj.ry" style="height: 30px; width:auto" />
          </a-col>
        </a-row>
        <a-row style="margin-top: 10px">
          <a-col :span="4">
            <img
                    style="width: 30px; height: 30px"
                    src="../../assets/img/z-rotate.png"
            />
          </a-col>
          <a-col :span="14">
            <a-slider v-model="pasterObj.rz" :min="-180" :max="180" />
          </a-col>
          <a-col :span="6">
            <a-input-number v-model="pasterObj.rz" style="height: 30px; width:auto" />
          </a-col>
        </a-row>
        <a-row style="margin-top: 10px">
          <a-col :span="4">
            <div class="icon-wrapper">
              <a-icon type="search" style="font-size: 18px; color: #c2c2c2" />
            </div>
          </a-col>
          <a-col :span="14">
            <a-slider
              v-model="pasterObj.scale"
              :min="0"
              :max="1.0"
              :step="0.01"
            />
          </a-col>
          <a-col :span="6">
            <a-input-number v-model="pasterObj.scale" style="height: 30px; width:auto" />
          </a-col>
        </a-row>
      </div>

      <div style="margin: 10px 20px">
        <span style="line-height: 4">{{$t('edit.injectInfo.positionAdjust')}}</span>
      </div>
      <div class="adjust-container">
        <FineTune @onClickAdjust="onClickAdjust"></FineTune>
      </div>
    </div>

    <div class="tool-drawer-btns">
      <DoubleBtn
              @onClickSave="handleClickSave"
              @onClickCancel="clickBack"
      ></DoubleBtn>
    </div>
  </div>
</template>

<script>
import MaterialSelect from "@/components/MaterialSelect";
import FineTune from "./FineTune.vue";
import { v4 as uuidv4 } from "uuid";
import DoubleBtn from "../DoubbleBtn";
import { mapGetters } from "vuex";

export default {
  components: { MaterialSelect, FineTune, DoubleBtn },
  props: {
    defaultValue: {
      type: Object,
    },
  },
  data() {
    return {
      pasterObj: {
        type: "video",
        title:'',
        paster_id: "paster" + uuidv4(),
        url: "",
        localurl: "",
        title: "",
        posterurl: "",
        ath: 0,
        atv: 0,
        rx: 0,
        ry: 0,
        rz: 0,
        scale: 0.5,
        autoplay: true,
        is_auto_play:1
      },
      originData: {
        rx: 0,
        ry: 0,
        rz: 0,
        scale: 0.5,
      },
    };
  },
  watch: {
    defaultValue: {
      handler: function (value) {
        if (value) {
          this.pasterObj = value;
          //保存原始數據
          // const data = Object.assign({}, value)
          // this.originData.ry = data.ry;
          // this.originData.rz = data.rz;
          // this.originData.scale = data.scale;
          // this.originData.rx = data.rx;
        }
      },
      immediate: true,
      deep: true,
    },
    newPasterObj: {
      handler: function (val, oldVal) {
        if (val.ath == "" && val.atv == "") {
          const vh = getSceneViewAt();
          this.pasterObj.ath = vh.hlookat;
          this.pasterObj.atv = vh.vlookat;
        }
        this.$emit("change", this.pasterObj, oldVal);
      },
      immediate: true,
      deep: true,
    },
  },
  computed: {
    ...mapGetters(["userInfo"]),
    newPasterObj() {
      return this.$deepClone(this.pasterObj);
    },
  },
  mounted() {
    this.$bus.$on("updatePaster", (e) => {
      if (e.paster_id == this.pasterObj.paster_id) {
        this.pasterObj.ath = e.ath;
        this.pasterObj.atv = e.atv;
      }
    });
  },
  methods: {
    clickBack() {
      this.$emit("clickBack", this.pasterObj);
    },
    clickDelete() {
      this.$emit("clickDelete", this.pasterObj);
    },
    handleClickSave() {
      this.$emit("saveDataToStore", {
        key: this.pasterObj.paster_id,
        data: this.pasterObj,
      });
    },
    handleSelectedVideo(item) {
      this.pasterObj.url = item.url;
    },
    handleSelectedCover(item) {
      this.pasterObj.posterurl = item.url;
    },
    onClickAdjust(direction) {
      if (this.pasterObj.url === "" || this.pasterObj.posterurl === "") {
        this.$message.error(this.$t('edit.editMessage.injectVideoAlert'));
        return;
      }
      console.log('onClickAdjust的direction',direction);
      if(direction === "left") {
        this.pasterObj.ath -= 1
      }
      if(direction === "right") {
        this.pasterObj.ath += 1
      }
      if(direction === "down") {
        this.pasterObj.atv += 1
      }
      if(direction === "top") {
        this.pasterObj.atv -= 1
      }
    },
    resetData() {
      console.log(this.pasterObj, this.originData)
      const data = Object.assign({}, this.originData)
      this.pasterObj.rx = data.rx;
      this.pasterObj.ry = data.ry;
      this.pasterObj.rz = data.rz;
      this.pasterObj.scale = data.scale;
    },
    isAutoPlay(e) {
      this.pasterObj.is_auto_play = e.target.checked ? 1 : 0;
    },
  },
};
</script>

<style lang="less" scoped>
.video-item {
  color: #505050;
  border: rgba(204, 204, 204, 1) solid 1px;
  padding: 4px;
  height: 50px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
